import { ShoppingCart, Wrench, CornerUpLeft, ShieldCheck, HeartHandshake, FileText, type LucideIcon } from "lucide-react";

/** Matches the reference prototype's POS.orderTypes exactly (label + icon), including the label
 *  "Return" (not "Return Order") — mapped to the backend's "Return Order" enum value at submit time. */
export const ORDER_TYPE_ICONS: Record<string, LucideIcon> = {
  "Sales Order": ShoppingCart,
  "Repair Order": Wrench,
  Return: CornerUpLeft,
  "Warranty Exchange": ShieldCheck,
  "Satisfaction Refund": HeartHandshake,
  Quote: FileText,
};

export type PosOrderTypeLabel = keyof typeof ORDER_TYPE_ICONS;
